// extracted by mini-css-extract-plugin
export default {"tradein_yesno":"MoreWaysAccordian_tradein_yesno__HWnqG"};